
export default function Footer() {
  return (
    <footer className="mt-16 border-t bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-sm text-slate-600">
          2025 Apar Growth Partners (Individual License – Aman R. Shah  SEBI Reg No : INA000020730)
        </div>
        <div className="text-sm text-slate-600">
         © All Rights Reserved  
          Apar Growth Partners
        </div>
      </div>
    </footer>
  );
}
